import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent, } from '@mui/material';
import { NavigateBefore, NavigateNext } from '@mui/icons-material';
import {useDispatch, useSelector} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPersonalizado, setearDatosAlStore } from 'store/actions/customAction';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import Formulario from 'components/formulario';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
import { mesesDelAnio, tipoDeMedio } from 'constantes/globalsStates';
import { functions } from 'constantes';

let rangoDeEdadesEnviar = [];
let idTipoDeMedio = "";
const DatosDemograficos = ({activeStep, numberStep, handleClose, datosDelMedio, tarifarioYDisponibilidad, cobertura, datosDemograficos, tituloModalDeConfirmacion, tarifario, tipoMedio, nitEmpresa}) => {

    const dispatch = useDispatch();
    const {datosGenerales} = useSelector((state) => state);
    const [catalogoRangoDeEdades] = useState('catalogoRangoDeEdades');
    const [tarifarioDeMediosTelevisivos] = useState('tarifarioDeMediosTelevisivos');
    const [tarifarioDeMediosRadiales] = useState('tarifarioDeMediosRadiales');
    const [tarifarioDeMediosEscritos] = useState('tarifarioDeMediosEscritos');
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false),
    [mostrarAlertaDeErrorOExito, setMostrarAlertaDeErrorOExito] = useState(false);
    const { ratingCanal, alcancePersonas, hombres, mujeres, alto, medio, bajo, edades } = datosDemograficos;
    const [respuestDeExito, setRespuestaDeExito] = useState("");

    useEffect(() => {
        obtenerRangoDeEdades();
    },[])

    const obtenerRangoDeEdades = async () => {
        const copiaDeCampos = Object.assign({}, camposDelFormulario);

        if(datosGenerales.rangoDeEdades.length > 0) {
            copiaDeCampos.edades.options = datosGenerales.rangoDeEdades?.map( ({id, rango}) => ({value: id , label: rango}) );
            return setCamposDelFormulario(copiaDeCampos);
        }

        setcargandoSolicitud(true);
        let respuesta = await dispatch(obtenerRegistrosPersonalizado({
            controller: catalogoRangoDeEdades,
            validateIfDataExists: true,
            stateInStore: datosGenerales.rangoDeEdades,
            dispatchAction: nombreDeAcciones.SETEAR_RANGO_DE_EDADES,
            nombreDelMetodo: "listar",
        }));

        setcargandoSolicitud(false);

        if(respuesta?.error || respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

        copiaDeCampos.edades.options = respuesta?.data?.map( ({id, rango}) => ({value: id , label: rango}) )
        setCamposDelFormulario(copiaDeCampos);
    }

    const calcularPorcentajeGenero = () => {
        const {hombres, mujeres} = camposDelFormulario;
        const sumarPorcentajes = Number(hombres?.value) + Number(mujeres?.value)
        return (sumarPorcentajes !== 100)
    }

    const calcularPorcentajeNivelSocioEconomico = () => {
        const {alto, medio, bajo} = camposDelFormulario;
        const sumarPorcentajes = Number(alto?.value) + Number(medio?.value) + Number(bajo?.value)
        return (sumarPorcentajes !== 100)
    }

    const handlerCheckbox = (value, dato, elemento) => {

        if (rangoDeEdadesEnviar.length > 0) {
            const existeValor = rangoDeEdadesEnviar.some(({idRango}) => idRango === elemento.value);
            if (existeValor) {
                const data = rangoDeEdadesEnviar.filter(({idRango}) => idRango !== elemento.value)
                rangoDeEdadesEnviar = data;
            }
            else rangoDeEdadesEnviar.push({idRango: elemento.value, rango: elemento.label})
        } else rangoDeEdadesEnviar.push({idRango: elemento.value, rango: elemento.label});
    }

    const [camposDelFormulario, setCamposDelFormulario] = React.useState({
        ratingAlcanceTitulo:{
            idelement: "ratingAlcanceTitulo", title:'RATING Y ALCANCE', position:"center", elementType:'titulo', showTitleForm: true, name: "ratingAlcanceTitulo", value: "", isError:false,
        },
        ratingCanal: {
            idelement: "ratingCanal",  value: ratingCanal, label: `Ingrese el rating ${tarifario} *`,pattern:"^\\d+(.[0-9]{2})?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"ratingCanal", 'disabled': false, width: '30%',
        },
        alcancePersonas: {
            idelement: "alcancePersonas",  value: alcancePersonas, label: "Ingrese el alcance en personas *", pattern:"^[0-9]{1,11}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"alcancePersonas", 'disabled': false, width: '30%'
        },
        perfilAudenciaTitulo:{
            idelement: "perfilAudenciaTitulo", title:'PERFIL DE LA AUDIENCIA EXPUESTA', position:"center", elementType:'titulo', showTitleForm: true, name: "perfilAudenciaTitulo", value: "", isError:false,
        },
        generoTitulo:{
            idelement: "generoTitulo", title:'GÉNERO', position:"center", elementType:'titulo', showTitleForm: true, name: "generoTitulo", value: "", isError:false, widthTitleForm:'80%'
        },
        alertaGenero:{
            idelement: "alertaGenero", mensaje:'EL PORCENTAJE DE GENERO DISTRIBUIDO DEBE SUMAR 100%.', elementType:'alerta', showAlertForm: true, name: "alertaGenero", value: "", isError:false, severity: 'error', width:'80%'
        },
        hombres: {
            idelement: "hombres",  value: hombres, label: "Hombres % *", pattern:"^[0-9]{1,3}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"hombres", 'disabled': false, width: '30%',
        },
        mujeres: {
            idelement: "mujeres",  value: mujeres, label: "Mujeres % *", pattern:"^[0-9]{1,3}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"mujeres", 'disabled': false, width: '30%',
        },
        nivelSocieconomicoTitulo:{
            idelement: "nivelSocieconomicoTitulo", title:'NIVEL SOCIOECONÓMICO', position:"center", elementType:'titulo', showTitleForm: true, name: "nivelSocieconomicoTitulo", value: "", isError:false, widthTitleForm:'80%'
        },
        alertaNivelSociecomico:{
            idelement: "alertaNivelSociecomico", mensaje:'EL PORCENTAJE DE NIVEL SOCIOECONÓMICO DISTRIBUIDO DEBE SUMAR 100%.', elementType:'alerta', showAlertForm: true, name: "alertaNivelSociecomico", value: "", isError:false, severity: 'error', width:'80%'
        },
        alto: {
            idelement: "alto",  value: alto, label: "Alto % *", pattern:"^[0-9]{1,2}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"alto", 'disabled': false, width: '27%',
        },
        medio: {
            idelement: "medio",  value: medio, label: "Medio % *", pattern:"^[0-9]{1,2}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"medio", 'disabled': false, width: '27%'
        },
        bajo: {
            idelement: "bajo",  value: bajo, label: "Bajo % *", pattern:"^[0-9]{1,2}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"bajo", 'disabled': false, width: '26%'
        },
        edadesTitulo:{
            idelement: "edadesTitulo", title:'EDADES', position:"center", elementType:'titulo', showTitleForm: true, name: "edadesTitulo", value: "", isError:false, widthTitleForm:'80%'
        },
        edades: {
            idelement: "edades", value: "", label: "Marque las edades *", isError: false, elementType: 'checkbox', errorMessages: ['Debe marcar al menos una opción'], options: [], 'disabled': false, isRequired: true, showInputCheckox: true, listValues: [], handler: handlerCheckbox, width: '50%', numberColumns: 3
        },
        acciones: {
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const cancelarAccion = () => {
        dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.LIMPIAR_TODO_EL_REDUCER}));
        handleClose(true);
    };

    const guardarDatos = async (dataForm) => {

        const porcentajeTotalDeGenero = calcularPorcentajeGenero()
        if(porcentajeTotalDeGenero) return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: `EL PORCENTAJE DE GENERO DISTRIBUIDO DEBE SUMAR 100%.`, mostrarRespuesta: true, });

        const porcentajeTotalNivelSocieconomico = calcularPorcentajeNivelSocioEconomico()
        if(porcentajeTotalNivelSocieconomico) return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: `EL PORCENTAJE DE NIVEL SOCIOECONÓMICO DISTRIBUIDO DEBE SUMAR 100%.`, mostrarRespuesta: true, });

        let departamentosDeCoberturaList = [];

        cobertura.listadoDeCoberturas.forEach( ({departamento, municipio}) => {
            const existeCobertura = departamentosDeCoberturaList.some((item) => Number(item.id) === Number(departamento.id) )
            if(existeCobertura) {
                departamentosDeCoberturaList = departamentosDeCoberturaList.map( item =>
                ({...item,
                    departamentosDeCobertura : item.departamentosDeCobertura.map( item2 =>
                        item2.idDepartamento === departamento.id ?
                        ({...item2, municipiosDeCobertura: [...item2.municipiosDeCobertura, {idMunicipio: municipio.id, nombreMunicipio: municipio.name}] })
                        : item2
                    )
                }))
            } else {
                departamentosDeCoberturaList.push({
                    id: departamento.id,
                    departamentosDeCobertura: [{
                        "idDepartamento": departamento.id,
                        "nombreDepartamento": departamento.name,
                        "municipiosDeCobertura": [{idMunicipio: municipio.id, nombreMunicipio: municipio.name}],
                    }]
                })
            }
        })

        let departamentosDeCoberturaAGuardar = [];

        departamentosDeCoberturaList.forEach( item => item.departamentosDeCobertura.forEach(item2 => departamentosDeCoberturaAGuardar.push(item2) ) )

        setcargandoSolicitud(true);

        const { alcancePersonas, alto, bajo, medio, hombres, mujeres, ratingCanal } = dataForm;
        const { julio, agosto, septiembre, octubre, noviembre, diciembre, disponibilidades} = tarifarioYDisponibilidad;

        const fechasDeDisponibilidad = disponibilidades.map(({fechaDesde, fechaHasta, cantidadDisponible}) =>
        ({
            "cantidadDisponible": Number(cantidadDisponible.name),
            "fechaFinal": functions.formatearFechaDD_MM_YYYY(fechaHasta),
            "fechaInicial": functions.formatearFechaDD_MM_YYYY(fechaDesde)
        }))

        const datosAGuardar = {
            cobertura: {
                departamentosDeCobertura: departamentosDeCoberturaAGuardar
            },
            datosDemograficos: {
                "alcanceEnPersonas": alcancePersonas,
                "nivelSocioEconomicoAlto": alto,
                "nivelSocioEconomicoBajo": bajo,
                "nivelSocioEconomicoMedio": medio,
                "porcentajeAudienciaHombres": hombres,
                "porcentajeAudienciaMujeres": mujeres,
                "rangoDeEdades": rangoDeEdadesEnviar,
                "ratingDelMedio": ratingCanal
            },
            disponibilidad: {
                fechasDeDisponibilidad
            },
            tarifarioPorMes: [
                {
                    "numeroDeMes": mesesDelAnio["julio"],
                    "tarifaDeMes": Number(julio)
                },
                {
                    "numeroDeMes": mesesDelAnio["agosto"],
                    "tarifaDeMes": Number(agosto)
                },
                {
                    "numeroDeMes": mesesDelAnio["septiembre"],
                    "tarifaDeMes": Number(septiembre)
                },
                {
                    "numeroDeMes": mesesDelAnio["octubre"],
                    "tarifaDeMes": Number(octubre)
                },
                {
                    "numeroDeMes": mesesDelAnio["noviembre"],
                    "tarifaDeMes": Number(noviembre)
                },
                {
                    "numeroDeMes": mesesDelAnio["diciembre"],
                    "tarifaDeMes": Number(diciembre)
                },
            ],
            nitEmpresa: nitEmpresa,
        }

        let controlador = "";

        switch(tipoDeMedio[tipoMedio]){
            case 1: // TELEVISION
                const { nombreDelCanal, numeroDelCanal, logoCanal, descripcionCanal } = datosDelMedio

                datosAGuardar.canalDeTercero = Number(datosDelMedio.estaRegistrandoCanal) === 1;
                datosAGuardar.nombreDelCanal = nombreDelCanal;
                datosAGuardar.numeroDelCanal = Number(numeroDelCanal);
                datosAGuardar.descripcion = descripcionCanal;
                datosAGuardar.logo = logoCanal;

                datosAGuardar.recepcionDeMateriales = {
                    correoDeRecepcion: datosDelMedio.correoElectronico,
                    diasDeAnticipacion: Number(datosDelMedio.diasDeAnticipacion),
                    especificacionesTecnicasDelMaterial: datosDelMedio.comentarioEspecificaciones
                }
                controlador = tarifarioDeMediosTelevisivos;
                break;
            case 2: // RADIO
                const { nombreDeLaRadio, estacion, frecuencia, logoRadio, descripcionRadio } = datosDelMedio
                datosAGuardar.radioDeTercero = Number(datosDelMedio.estaRegistrandoCanal) === 1;
                datosAGuardar.estacion = Number(estacion);
                datosAGuardar.frecuencia = frecuencia?.id;
                datosAGuardar.nombreDeLaRadio = nombreDeLaRadio;
                datosAGuardar.descripcion = descripcionRadio;
                datosAGuardar.logo = logoRadio;

                datosAGuardar.recepcionDeMateriales = {
                    correoDeRecepcion: datosDelMedio.correoElectronico,
                    diasDeAnticipacion: Number(datosDelMedio.diasDeAnticipacion),
                    especificacionesTecnicasDelMaterial: datosDelMedio.comentarioEspecificaciones
                }
                controlador = tarifarioDeMediosRadiales;
                break;
            case 3: // escritos
                const { nombreDelMedioEscrito, circulacion, distribucion, logoDelMedio, descripcionDelMedio, tipoEscrito } = datosDelMedio
                datosAGuardar.nombreDelMedioEscrito = nombreDelMedioEscrito;
                datosAGuardar.tipoDeCirculacion = circulacion?.id;
                datosAGuardar.tipoDeDistribucion = distribucion?.id;
                datosAGuardar.tipoDeMedioEscrito = tipoEscrito?.id;
                datosAGuardar.descripcion = descripcionDelMedio;
                datosAGuardar.logo = logoDelMedio;

                datosAGuardar.recepcionDeMateriales = {
                    correoDeRecepcion: datosDelMedio.correoElectronico,
                    diasDeAnticipacion: Number(datosDelMedio.diasDeAnticipacion),
                    especificacionesTecnicasDelMaterial: datosDelMedio.comentarioEspecificaciones
                }
                controlador = tarifarioDeMediosEscritos;
                break;
            default:
                break;
        }

        let datosAEnviar = {};
        let response = {};

        if(idTipoDeMedio) {
            datosAGuardar.idInforme = idTipoDeMedio
            datosAEnviar = { controller: controlador, action: 'editar', data: datosAGuardar };
            response = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
        } else {
            datosAEnviar = { controller: controlador, action: 'crear', data: datosAGuardar };
            response = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
        }
        setcargandoSolicitud(false);

        if(response?.error) return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: response.error?.message || "REGISTRO NO INGRESADO. INTENTE NUEVAMENTE", mostrarRespuesta: true, });
        setRespuestaDeExito(response?.data?.data)
        setMostrarAlertaDeErrorOExito(true);
    }

    const regresar = (dataForm) => {
        dataForm.edades = camposDelFormulario.edades.listValues;

        dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SETEAR_DATOS_DEMOGRAFICOS,
            data: {
                datosDemograficos: dataForm,
                activeStep : activeStep - 1,
                numberStep : numberStep - 1
            }
        }));
    };

    const [buttonList]= React.useState({
        "regresar":{"label":"Regresar", "icon": <NavigateBefore />,"callback":regresar,"loading":false,"size":"medium",
            "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
            "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false, isCancel: true,
        },
        "guardarDatos":{"label":"Guardar datos", "icon": <NavigateNext />, "callback":guardarDatos,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <NavigateNext />,"callback":cancelarAccion,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => {
        setDatosDeRespuesta({tipoDeAlerta,mensajeDeAlerta,mostrarRespuesta,})
    };

    const cerrarAlertaDeConfirmacion = () => {
        dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.LIMPIAR_TODO_EL_REDUCER}));
        handleClose(true);
        setMostrarAlertaDeErrorOExito(false);
    }

    const manejadorAccionDelModal = async () => {
        dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.LIMPIAR_TODO_EL_REDUCER}));
    }

    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>
            <Card>
                <CardContent>
                    <Formulario
                        elements={camposDelFormulario}
                        buttonList={buttonList}
                    />
                </CardContent>
            </Card>
            {mostrarAlertaDeErrorOExito && (
                <ModalDeConfirmacion
                    title={`¿Desea agregar ${tituloModalDeConfirmacion}?`} message={respuestDeExito || "¡REGISTRADO CORRECTAMENTE!"}
                    open={mostrarAlertaDeErrorOExito} closeModal={cerrarAlertaDeConfirmacion} titleButton={"Sí, agregar"}
                    actionAdd={manejadorAccionDelModal}
                />
            )}
        </Fragment>
    );
}

export default DatosDemograficos;